import get from "lodash.get";

import AbstractApiUtils from "services/cores/abstractApiUtils";
import MapUtils from "services/map/utils";
import ParkStatisticsUtils from "services/parkStatistics/utils";

class NonMovingCarsUtils extends AbstractApiUtils {
  getFilters = (type = "default", state) => {
    const { position, radius, include_is_unavailable } = state.GlobalFilters;
    const { areaType, duration } = state?.NonMovingCars?.filters;
    const selectLayers =
      ParkStatisticsUtils.getSelectedLayers(state.ParkStatistics) || [];
    const floorLevel = MapUtils.getFloor(state.Map);
    let data = {};
    let filters = {};

    if (get(areaType, "length", 0) > 0) {
      filters = {
        area: {
          "type ($IN)": areaType,
        },
      };
    }

    if (type === "radius" && floorLevel !== null && floorLevel !== undefined) {
      filters = {
        ...filters,
        area: { ...get(filters, "area", {}), floor_level: floorLevel },
      };
    }

    if (type === "areas") {
      const areas = selectLayers
        .filter(
          (layer) =>
            floorLevel === undefined ||
            floorLevel === null ||
            get(layer, "floor_level") === floorLevel
        )
        .map((selectedLayer) => get(selectedLayer, "id"));

      if (areas.length > 0) {
        data = { ...data, areas };
      }
    }

    if (type === "radius") {
      data = { ...data, radius, position };
    }

    // Only one sort at a time
    const orders = Object.keys(
      get(state.NonMovingCars.list, "orders", {})
    ).reduce((currentOrder, key) => {
      const orderBy = get(state.NonMovingCars.list.orders, key, "");
      if (orderBy === "asc" || orderBy === "desc") {
        return {
          sort_by: key,
          order_by: orderBy,
        };
      }
      return currentOrder;
    }, {});

    return {
      ...data,
      duration,
      filters,
      ...orders,
      include_is_unavailable,
    };
  };

  formatListFromApi = (list) => {
    return {
      items: get(list, "non_moving_cars", []),
      others: {
        timestamp: this.getApiTimestamp(list),
      },
    };
  };
}

export default new NonMovingCarsUtils();
